import IconLabel from "./IconLabel";
import Person2Icon from "@mui/icons-material/Person2";

const ContactNameLabel = (props) => (
  <IconLabel icon={<Person2Icon />} fallback="Not entered" {...props} />
);

export default ContactNameLabel;
